import React from 'react';

function Logo() {
    return <div>Test task</div>;
}

export { Logo };
